import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import Images from '../images'

// Add useNavigate to the imports
import {  useNavigate } from "react-router-dom";
const MedicalSuccessPage = () => {
   const navigate = useNavigate();
  const [showElements, setShowElements] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const location = useLocation();
  const { referenceId, name, email, formType } = location.state || {};
 useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  useEffect(() => {
    setTimeout(() => setShowElements(true), 200);
    setTimeout(() => setShowMessage(true), 800);
  }, []);

  return (
    <div className="min-vh-100 bg-light position-relative d-flex align-items-center justify-content-center p-4 overflow-hidden">
      <div className="container">
        <div className="row g-10 align-items-center">

          {/* Left Side Illustration */}
          <div className="col-lg-6 text-center mb-5 mb-lg-0">
            <div className={`transition-all ${showElements ? 'opacity-100' : 'opacity-0'}`}>
              <div className="position-relative d-inline-block">
                <div className="circle-wrapper">
                  <img 
                    src={Images.Thanks}
                    alt="Character"
                    className="w-100 h-100 object-fit-cover"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Right Side Message */}
          <div className={`col-lg-6 text-center text-lg-start transition-all ${showMessage ? 'opacity-100' : 'opacity-0'}`}>
            
            {/* Success Icon */}
           

            {/* Main Title */}
           {/*  <h1 className="fw-bold text-dark mb-3">Thank You</h1> */}
            <p className="text-muted mb-4 fs-5">
              Your application has been successfully submitted! We look forward to reviewing it.
            </p>

            {/* Reference Info */}
           <div className="info-box shadow mb-4">
      <div className="mb-3">
        <small className="text-success">Reference ID</small>
        <p className="fw-semibold mb-0 text-success">{referenceId || "--"}</p>
      </div>
      <div className="d-flex  mb-2">
        <span className="text-muted">Name:</span>
        <span className="fw-semibold">{name || "--"}</span>
      </div>
      <div className="d-flex  mb-2">
        <span className="text-muted">Email:</span>
        <span className="fw-semibold">{email || "--"}</span>
      </div>

        <div className="d-flex  mb-2">
        <span className="text-muted">Submitted Form:</span>
        <span className="fw-semibold">{formType || "--"}</span>
      </div>
    </div>

            {/* Action Button */}
            <button 
    className="btn btn-view d-flex align-items-center mx-auto mx-lg-0"
    onClick={() => navigate('/')}
  >
    Back to Site <i className="fa fa-arrow-right ms-2"></i>
  </button>
            {/* Contact */}
            <p className="text-muted mt-4 mail-text">
              Need help? Contact us at <span className="fw-semibold text-primary">support@med-engage.com</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MedicalSuccessPage;
